module.exports = __webpack_public_path__ + "img/ico_modal_danger.71d0e062.svg";